/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable import/prefer-default-export */
import { useReducer, useEffect } from 'react';
import axios from 'axios';
import qs from 'qs';
import toastr from 'toastr';
import * as load from '../../../../constants/types/shared/LoadingTypes';
import * as types from '../../../../constants/types/asset-team/AssetTeamTypes';
import { expiredCustomerReducer } from '../../../../reducers/shared/asset-team/expired-customers/expiredCustomerReducer';
import { GET_ROUTER_URL } from '../../../../services/api/shared/BasestationsUrl';

export const useExpiredCustomers = () => {
  const [{ items, time, customers, total, isLoading }, dispatch] = useReducer(expiredCustomerReducer, {
    items: [],
    time: '',
    customers: [],
    total: 0,
    isLoading: false,
  });

  useEffect(() => {
    async function getExpiredCustomer() {
      const params = {
        action: 'tizeti_asset_expiration_count_get_cron',
      };
      const config = {
        method: 'post',
        url: `${GET_ROUTER_URL}`,
        data: qs.stringify(params),
      };

      await axios(config)
        .then((response) => {
          // console.log('response', response.data);
          if (response.data !== '') {
            dispatch({
              type: types.GET_EXPIRED_CUSTOMER,
              payload: {
                items: response.data.expired_per_basestation.items,
                time: response.data.readable_last_updated_at,
                total: response.data.total_expired,
              },
            });
          }
        })
        .catch((error) => {
          // console.log('error::::', error);
          if (error) {
            toastr.info('Something went wrong!');
            dispatch({ type: load.LOADING_STOPS });
          }
        });
    }
    getExpiredCustomer();
  }, []);

  const getExpiredDetails = async (data) => {
    dispatch({
      type: load.LOADING_STARTS,
    });
    try {
      const response = await axios.post(`${GET_ROUTER_URL}`, qs.stringify(data));
      if (response.data) {
        dispatch({
          type: types.GET_EXPIRED_CUSTOMER_DETAILS,
          payload: response.data.items,
        });
      } else
        dispatch({
          type: load.LOADING_STOPS,
        });
    } catch (e) {
      toastr.info('Something went wrong!');
      dispatch({
        type: load.LOADING_STOPS,
      });
    }
  };

  return {
    time,
    items,
    total,
    customers,
    isLoading,
    getExpiredDetails,
  };
};
